import React, { useEffect, useState, useRef, ChangeEvent } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { AppBar, useTheme, TextField, Chip, Button } from "@mui/material";
import { Link, useHistory, Redirect } from 'react-router-dom';
import { APIGetLoggersModel } from '../../models/APIGetLoggersModel'
import { isLCLLogger } from 'variables/chariotProductIds';
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';
import { useMobileContext } from '../../Context/ContextProvider'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    deviceData: Array<APIGetLoggersModel>
}

interface RedirectProps {
    serial: number | null
}

const Search: React.FC<Props> = ({deviceData }) => {
    
    ///hooks
    const theme = useTheme()
    const searchRef = useRef(null)
    const textInputRef = useRef(null)
    const history = useHistory()
    const isMobile = useMobileContext()

    //state 
    const [searchOpen, setSearchOpen] = useState<boolean>(false)
    const [searchContent, setSearchContent] = useState<string>("")
    const [searchDisplayText, setSearchDisplayText] = useState<string>("")
    const [searchResults, setSearchResults] = useState<Array<APIGetLoggersModel> | null>([])
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({serial: 0})


    const handleSearchClick = () => {
        setSearchOpen(!searchOpen)
        if (textInputRef && textInputRef.current) {
            textInputRef.current.focus()
        }
    }

    const handleResultClick = (serial: number | undefined, model: string | undefined): void => {

        const targetPath = !isLCLLogger(model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail';
        //history.replace(targetPath, { serial: serial });
        history.push(targetPath, { serial: serial });
        //window.location.reload();
        //setRedirect(true)
        //setRedirectPath(!isLCLLogger(model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        //setRedirectProps({
        //    serial: typeof (serial) === 'number' ? serial : serial
        //})
        setSearchContent("")
        setSearchResults([])
        setSearchOpen(false)
        setSearchDisplayText("")
    }

    const handleClearClick = (): void => {
        setSearchContent("")
        setSearchDisplayText("")
        setSearchResults([])
        setTimeout(() => {
            if (textInputRef && textInputRef.current) {
                const element = textInputRef.current as HTMLElement
                const inputElement = element.querySelector('input') as HTMLElement
                if (inputElement) {
                    inputElement.focus()
                }
            }
        }, 100)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
                setSearchOpen(false)
                setSearchContent("")
                setSearchDisplayText("")
                setSearchResults([])
            }
        }


        if (searchOpen) {
            document.addEventListener('mousedown', handleClickOutside)
            
        }

        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [searchOpen])

    const handleSearchQuery = (e: ChangeEvent<HTMLInputElement>): void => {
        setSearchContent(e.target.value.toLowerCase())
        setSearchDisplayText(e.target.value)
    }


    useEffect(() => {
        if (searchContent.length > 2) {
            const results = deviceData.map(d => {
                if (d.Site) {
                    d.Site = d.Site.toLowerCase()
                }
                if (d.SiteName) {
                    d.SiteName = d.SiteName.toLowerCase()
                }
                if (d.SiteNameUserFriendly) {
                    d.SiteNameUserFriendly = d.SiteNameUserFriendly.toLowerCase()
                }
                return d
            }).filter(d => {
                if (String(d.Serial).includes(searchContent)) {
                    return d
                }
                if (d.SiteName && d.SiteName.includes(searchContent)) {
                    return d
                }
                if (d.SiteNameUserFriendly && d.SiteNameUserFriendly.includes(searchContent)) {
                    return d
                }
                if (d.Site && d.Site.includes(searchContent)) {
                    return d
                } else {
                    return
                }
            })
            setSearchResults(results)

        }
        if (searchContent.length <= 2) {
            setSearchContent("")
            setSearchResults([])
        }
    }, [searchContent])

    return (
        !redirect ? (
        <div style={{ margin: "6px 15px 0 0", position: "relative" }}>
            <div onClick={(): void => handleSearchClick()}>
                <SearchIcon fontSize="large" style={{ color: searchOpen ? theme.palette.primary.main : "white", cursor: "pointer" }} />
            </div>
            {searchOpen && <SlideInAnimation direction="top" duration={0.8} delay={0.2} transitionAmount={50} isVisible={searchOpen}>
                <div style={{ position: "fixed", width: isMobile ? "90vw" : "20vw", right: isMobile ? "-13vw" : "0", zIndex: 100000, background: "white", borderRadius: "3px" }} ref={searchRef}>
                    <div style={{ position: "relative" }}>
                        <TextField ref={textInputRef} size="medium" fullWidth value={searchDisplayText} autoFocus autoComplete="off" onChange={(e: ChangeEvent<HTMLInputElement>): void => handleSearchQuery(e)} />
                        {searchContent.length > 0 && <div style={{ position: "absolute", right: 9, top: 9 }}>
                            <Button color="warning" variant="contained" onClick={(): void => handleClearClick()} ><FormattedMessage id='Clear' /></Button>
                        </div>}
                    </div>
                    {searchResults && searchResults.length > 0 &&
                        <div style={{
                            border: "1px solid #eeeeee",
                            maxHeight: "700px", // or whatever height makes sense
                            overflowY: "auto" }}>
                            {searchResults.map((res: APIGetLoggersModel) => {
                                return (<div
                                    onClick={(): void => { handleResultClick(res.Serial, res.Model) }}
                                    style={{
                                        borderBottom: "1px solid #eeeeee",
                                        margin: "5px",
                                        padding: "10px",
                                        boxShadow: "0 0 10px black",
                                        borderRadius: '3px',
                                        cursor: 'pointer'
                                    }} key={res.Serial}>
                                    <div style={{ width: "100%", padding: "10px", height: "100%", display: "flex", borderBottom: "1px solid gray" }}>
                                        <div style={{ width: "33%" }}>
                                            <p><FormattedMessage id='Serial' /></p>
                                            <div>
                                                <Chip size="medium" label={res.Serial} />
                                            </div>
                                        </div>
                                        <div>
                                            <p><FormattedMessage id='Device Name' /></p>
                                            <p><b>{res.Site}</b></p>
                                        </div>
                                    </div>

                                    <div style={{ width: "100%", padding: "14px 10px 5px 10px" }}>
                                        <p><FormattedMessage id='Site' /></p>
                                        <p><b>{res.SiteName} ({res.SiteNameUserFriendly})</b></p>
                                    </div>
                                </div>)
                            })}
                        </div>
                    }
                </div>
            </SlideInAnimation>}

            </div>) :
            (<Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />)
    )
}
export default Search